<template>
  <div class="table-container">
    <table class="content-table">
      <thead class="header-table">
      <tr class="trhead">
        <th>{{ $t('product') }}</th>
        <th>{{ $t('amount') }}</th>
        <th>{{ $t('status') }}</th>
        <th>{{ $t('date') }}</th>
        <th>{{ $t('buyer_company_info') }}</th>
        <th>{{ $t('bill') }}</th>
      </tr>
      </thead>
      <tbody class="tbody-container">
      <tr class="tr-class" v-if="!loading" v-for="(item, index) in items" :key="item.uuid || item.id || index">
        <td @click="viewDetails(item)" class="td-style">
          <div class="name-row">
            <template v-if="item?.product?.images && Array.isArray(item.product.images) && item.product.images.length > 0 && item.product.images[0]">
              <img
                  class="product-image"
                  :src="item.product.images[0]"
                  alt="Product"
                  @error="handleImageError"
              />
            </template>
            <template v-else>
              <div class="no-image-placeholder">
                <img :src="defaultImage" class="placeholder-icon" alt="No image" />
              </div>
            </template>
            <span v-if="item?.product?.title" class="product-title">
              {{ truncateText(item.product.title, 45) }}
            </span>
            <em v-else class="no-data-text">N/A</em>
          </div>
        </td>
        <td class="td-style">
          <span v-if="item?.invoiceInfo?.pricing" class="price-info">
            {{ item.invoiceInfo.pricing.finalPrice }} {{ item.invoiceInfo.pricing.currency }}
          </span>
          <span v-else class="no-data-text">N/A</span>
        </td>
        <td class="td-style">
          <span class="status-badge" :class="item?.isCompleted ? 'paid' : 'notpaid'">
            <span class="status-dot"></span>
            <span v-if="item?.isCompleted">{{ $t('payment_finished') }}</span>
            <span v-else>{{ $t('payment_couldnt_finished') }}</span>
          </span>
        </td>
        <td class="td-style">
          <span class="date-info">
            <img src="../../../assets/images/datepicker.svg" alt="Date">
            {{ formatDate(item?.createdAt) }}
          </span>
        </td>
        <td class="td-style">
          <div class="buyer-company-cell">
            <img
                class="product-image"
                :src="item?.buyerCompany?.logo || defaultImage"
                :alt="item?.buyerCompany?.name || 'Company'"
                @error="handleImageError"
            >
            <span>{{ item?.buyerCompany?.name || 'N/A' }}</span>
          </div>
        </td>
        <td class="td-style">
          <span>{{ item?.invoiceInfo?.invoiceNumber || 'N/A' }}</span>
        </td>
      </tr>
      <tr v-else>
        <td colspan="6" class="table-loading">
          <VueSpinner size="16" height="100%" color="#8c8c8c" />
          <span class="text">{{ $t('loading') }}</span>
        </td>
      </tr>

      <tr v-if="!loading && items.length === 0">
        <td colspan="6" class="table-loading">
          <span class="no-data-found">{{ $t('no_data_found_sales') }}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { VueSpinner } from "vue3-spinners";
import defaultImage from '@/assets/images/ibility-default.jpeg';

export default {
  name: 'MySalesTable',
  components: {
    VueSpinner,
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      defaultImage: defaultImage
    }
  },
  watch: {
    items: {
      handler(newVal, oldVal) {
        if (newVal && newVal.length > 0) {
        }
      },
      immediate: true,
      deep: true
    },
    loading: {
      handler(newVal, oldVal) {
      },
      immediate: true
    }
  },
  mounted() {
  },
  beforeUnmount() {
  },
  methods: {
    viewDetails(item) {

      if (item?.productUuid) {
        this.$router.push(`/marketplace/product/${item.productUuid}`);
      } else {
      }
    },
    handleImageError(event) {
      event.target.src = this.defaultImage;
    },
    truncateText(text, maxLength) {
      if (!text) return "";
      return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('tr-TR', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
      } catch (error) {
        return 'N/A';
      }
    }
  }
}
</script>

<style scoped>
.table-container {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.content-table {
  width: 100%;
  border-collapse: collapse;
}

.header-table {
  background: #f8f9fa;
}

.trhead th {
  padding: 12px 16px;
  font-weight: 600;
  font-size: 12px;
  color: #475467;
  border-bottom: 1px solid #eaecf0;
  text-transform: none !important;
}

.tbody-container tr {
  border-bottom: 1px solid #eaecf0;
}

.tbody-container tr:hover {
  background: #f9fafb;
}

.td-style {
  padding: 16px;
  vertical-align: middle;
  text-align: center;
}

.name-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.product-image {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
  border: 1px solid #e1e5e9;
}

.no-image-placeholder {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e1e5e9;
}

.placeholder-icon {
  width: 20px;
  height: 20px;
  opacity: 0.5;
}

.product-title {
  font-weight: 500;
  color: #101828;
  font-size: 14px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.paid {
  background: #d1fadf;
  color: #0d894f;
}

.status-badge.notpaid {
  background: #fef3c7;
  color: #92400e;
}

.tr-class {
  cursor: pointer;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.status-badge.paid .status-dot {
  background: #0d894f;
}

.status-badge.notpaid .status-dot {
  background: #92400e;
}

.date-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
  color: #475467;
}

.date-info img {
  width: 16px;
  height: 16px;
}

.price-info {
  font-weight: 600;
  color: #101828;
  font-size: 14px;
}

.table-loading {
  text-align: center;
  padding: 40px 20px;
}

.no-data-text {
  font-style: italic;
  color: #9ca3af;
  font-size: 12px;
}

.buyer-company-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}
</style>
